<template>
  <div id="login">
    <div class="login_wrap">
      <div class="login_top">
        <img src="../assets/login/bg_lguplus_logo.png"/>
        <img src="../assets/login/bg_kepc_logo.png"/>
      </div>
      <div class="login_left">
        <div>고객과 함께하는 KEPCO</div>
        <div>고객이 신뢰하는 LG U+</div>
        <div>
          <div>보안을 위해 주기적으로 비밀번호를 변경해 주세요. 계정이 없으신 분은 <span @click="toggleLoginAndTerms">계정신청</span>을 해주세요.</div>
          <div>고객과 함께하는 KEPCO</div>
          <div>고객이 신뢰하는 LG U+</div>
        </div>
      </div>
      <div class="login_right">
        <div class="login_right_top">
          <img src="../assets/login/bg_lguplus_logo.png"/>
          <img src="../assets/login/bg_kepc_logo.png"/>
        </div>
        <div class="login_right_middle" v-if="isLoginForm">
          <div class="login_tit">로그인</div>
          <div class="login_desc">회원 전용 시스템입니다. 로그인 후 이용해주세요.</div>
          <template v-if="isMobileBrowser">
            <div class="login_input_wrap">
              <label>아이디</label>
              <input type="text" v-model="userId" @keyup.enter="login" placeholder="아이디"/>
            </div>
            <div class="login_input_wrap">
              <label>패스워드</label>
              <input type="password" v-model="password" @keyup.enter="login" placeholder="패스워드"/>
            </div>
          </template>
          <template v-else>
            <div class="login_input_wrap">
              <label>아이디</label>
              <input type="text" v-model="userId" @keyup.enter="login"/>
            </div>
            <div class="login_input_wrap">
              <label>패스워드</label>
              <input type="password" v-model="password" @keyup.enter="login"/>
            </div>
          </template>
          <div class="login_checkbox_wrap">
            <input type="checkbox" id="check_auto_login" v-model="isSaveID"/>
            <label for="check_auto_login">아이디 저장</label>
          </div>
          <div class="btn_login" @click="login">로그인</div>
        </div>
        <div class="login_right_middle terms" v-else>
          <div class="login_tit">계정 등록 신청</div>
          <div class="login_desc">관리자의 승인 이후, 사이트의 이용이 가능합니다.</div>
          <div class="join_term_wrap">
            <div class="join_term_tit">회원약관(서비스 이용약관)</div>
            <div class="join_term_content">
              <div class="join_term_top_fade"></div>
              <div class="join_term_bottom_fade"></div>
              <div class="join_term_box">
                <div>
                  <!-- TODO: 이용약관 필요 -->
                  제1조 (목적) 본 회원약관은 ㈜엘지유플러스(이하 '엘지유플러스'라 한다)이 ㈜한국전력공사(이하 ‘한전’이라 한다)에 납품하는 원격검침용 모뎀 운용 관리 업무를 수행하는 [사이트명](사이트명 소개)(이하 ' 사이트명'라 한다)를 이용함에 있어 이용자의 권리, 의무 및 책임사항과 [사이트명] 사이트에서 행해지는 모든 활동에 대한 규정을 목적으로 한다.
                  <br><br>제2조 (약관의 효력) 1.본 약관은 [사이트명] 사이트에 회원 가입 시 회원들에게 통지함으로써 효력을 발생한다. 2.엘지유플러스는 이 약관의 내용을 변경할 수 있으며, 약관의 변경사항 및 내용은 사전에 한전과 협의하고 사이트에 공지함으로써 효력이 발생한다.
                  <br><br>제3조 (회원의 의무) 1.회원은 관계법령, 이 약관의 규정, 이용안내 및 주의사항 등 [사이트명]에서 통지하는 사항을 준수하여야 하며, 기타 한전,엘지유플러스 업무에 방해되는 행위를 하여서는 안된다. 2.본 [사이트명] 사이트를 통해 제공되는 정보는 한전의 운용 관리 업무 진행 및 정보 조회를 위해서 사용하여야 하며, 어떤 이유로든 재배포할 수 없다. 3.회원은 한전과 엘지유플러스의 사전 승낙 없이 [사이트명] 사이트를 이용하여 어떠한 영리 행위도 할 수 없으며 관련 정보를 무단으로 배포할 경우 민사 및 형사상의 처벌을 받게 된다. 3.회원은 [사이트명] 사이트를 이용하여 얻은 정보를 한전과 엘지유플러스의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판·방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없다. 4. 본 [사이트명] 사이트의 정보 배포는 한전, 엘지유플러스 또는 양사와 협력관계에 있는 업체 임직원을 대상으로 하며 실명과 사실로 가입한 회원을 대상으로 한다. 5. 회원은 [사이트명] 사이트 이용과 관련하여 다음 각 호의 행위를 하여서는 안되며, 다음 각 호의 행위를 하는 경우 한전과 엘지유플러스 합의하에 회원을 강제 탈퇴 시킬 수 있다. ①다른 회원의 아이디(ID)를 부정 사용하는 행위 ②범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위 ③타인의 지적재산권 등의 권리를 침해하는 행위 ④해킹행위 또는 컴퓨터바이러스의 유포행위 ⑤[사이트명] 사이트의 안전적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위 ⑥기타 관계법령에 위배되는 행위 ⑦게시판 등 커뮤니티를 통한 상업적 광고홍보 또는 상거래 행위
                  <br><br>제4조 (이용신청) 1. 회원 가입은 온라인으로 가입신청 양식에 기록하여 제출함으로써 이용신청을 할 수 있다. 2. 가입을 희망하는 회원은 반드시 자신의 본명, 회사, 이동전화번호,담당업무,담당지역 및 이메일 주소를 등록하고 이용신청을 하여야 한다 3.한전과 엘지유플러스 관리자는 해당 각사의 사용자를 승인, 탈퇴, 관리 등 모든 사용자 관리를 책임지며 이에 따른 단말정보 유출등에 모든 법적인 책임은 관리자에게 있다.
                  <br><br>제5조 (회원가입의 승낙) 회원 가입 신청 양식에 가입 희망 회원이 인터넷으로 제4조와 같이 신청하면 한전,엘지유플러스 관리자는 심사를 거쳐 정식 회원으로 가입을 승인하고 신청시 작성한 메일 주소로 가입승인 메일을 보낸다. 회원은 [사이트명] 사이트에 접속하여 ID/PASS 를 입력하면 본 [사이트명] 사이트에서 제공하는 서비스를 이용할 수 있다. 제6조(회원가입 신청거절 및 강제 탈퇴) 한전, 엘지유플러스 관리자는 타인의 명의나 이동전화번호, 이메일 주소를 도용하여 회원가입신청을 할 경우 회원가입신청을 거절할 수 있다. 또한, 회원가입신청이 승인이 된 후에도 허위사실의 기재가 발각되거나 회사의 명예를 훼손시키거나 제3조의 회원의 의무를 다하지 않았을 경우 강제 탈퇴시킬 수 있다.
                  <br><br>제7조 (엘지유플러스의 의무) 1. 엘지유플러스는 계속적, 안정적으로 서비스를 제공할 수 있도록 최선의 노력을 다하여야 한다. 2. 엘지유플러스는 서비스에 관련된 설비를 항상 운용할 수 있는 상태로 유지 보수하고, 장애가 발생하는 경우 지체없이 이를 수리·복구할 수 있도록 최선의 노력을 다하여야 한다. 3. 엘지유플러스는 회원의 정보를 회원의 사전동의 없이 제3자에게 배포 또는 누락하지 않는다. 4. 엘지유플러스는 회원의 건의사항이나 불만사항을 신속하게 처리하여야 한다.
                  <br><br>제8조 (개인정보보호) 한전,엘지유플러스 관리자는 관련법령이 정하는 바에 따라서 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위하여 노력합니다. 이용자의 개인정보보호에 관해서는 관련법령 및 회사가 정하는 "개인정보보호정책"에 정한 바에 의합니다.
                  <br><br>제9조 (게시물 또는 내용물의 삭제) 한전,엘지유플러스 관리자는 서비스의 게시물 또는 내용물이 제12조의 규정에 위반되거나 회사 소정의 게시기간을 초과하는 경우 사전 통지나 동의 없이 이를 삭제할 수 있다.
                  <br><br>제10조 (게시물에 대한 권리·의무) 게시물에 대한 저작권을 포함한 모든 권리 및 책임은 이를 게시한 회원에게 있다.
                  <br><br>제11조 (양도금지) 회원이 서비스의 이용권한, 기타 이용계약상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없다.
                  <br><br>제12조 (계약해지 및 이용제한) 1.회원이 이용계약을 해지하고자 하는 때에는 본인이 서비스를 통하여 이를 회사에 신청하여야 한다. 2.한전,엘지유플러스 관리자는 회원이 제12조 약관의 내용을 위반하고, 회사 소정의 기간 이내에 이를 해소하지 아니하는 경우 이용 계약을 해지할 수 있다. 3.한전,엘지유플러스 관리자는 회원이 회사 또는 협력업체에서 퇴사 또는 다른 이유로 관련 업무가 중지될 때 이용 계약을 해지할 수 있다. 4.회원 명부에서 탈퇴하는 경우에도 제3조, 제 9조, 제 10조의 내용은 유효하다.
                  <br><br>제13조 (손해배상) 한전,엘지유플러스는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 손해가 한전,엘지유플러스의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부담하지 아니한다.
                  <br><br>제14조 (면책·배상) 1.한전,엘지유플러스는 회원이 게재한 정보, 자료, 사실의 정확성, 신뢰성 등 그 내용에 관하여는 어떠한 책임을 부담하지 아니하고, 회원은 자기의 책임아래 서비스를 이용하며, 서비스를 이용하여 게시 또는 전송한 자료 등에 관하여 손해가 발생하거나 자료의 취사 선택, 기타 서비스 이용과 관련하여 어떠한 불이익이 발생 하더라도 이에 대한 모든 책임은 회원에게 있다. 2.한전,엘지유플러스는 제12조의 규정에 위반하여 회원간 또는 회원과 제3자간에 서비스를 매개로 하여 물품거래 등과 관련하여 어떠한 책임도 부담하지 아니하고, 회원이 서비스의 이용과 관련하여 기대하는 이익에 관하여 책임을 부담하지 않는다. 3.회원 아이디(ID)와 비밀번호의 관리 및 이용상의 부주의로 인하여 발생 되는 손해 또는 제3자에 의한 부정사용 등에 대한 책임은 모두 회원에게 있다. 4.회원이 제3조, 기타 이 약관의 규정을 위반함으로 인하여 회사가 회원 또는 제3자에 대하여 책임을 부담하게 되고, 이로써 회사에게 손해가 발생하게 되는 경우, 이 약관을 위반한 회원은 회사에게 발생하는 모든 손해를 배상하여야 하며, 동 손해로부터 회사를 면책시켜야 한다. 제15조 (분쟁의 해결) 1.한전과 엘지유플러스 회원은 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 한다. 2.1항의 규정에도 불구하고 분쟁으로 인하여 소송이 제기될 경우 소송은 회사의 본사소재지를 관할하는 법원의 관할로 한다. 제16조 (이용계약의 체결) 회원 가입 시 회원 신청약관 밑에 있는 '동의'버튼을 회원이 누르면 약관에 동의하여 이 계약이 체결된 것으로 간주한다. 부 칙 제 1 조 (시행일) 이 약관은 2023년 9월1 일부터 시행한다.
                </div>
              </div>
            </div>
            <div class="join_term_bottom_wrap">
              <div class="join_term_check">
                <input type="checkbox" id="checkAgree" v-model="checkAgree"/>
                <label for="checkAgree">약관에 동의합니다.</label>
              </div>
              <div class="btn_join_prev" @click="toggleLoginAndTerms">로그인</div>
              <div class="btn_join_next" @click="requestSignup">다음</div>
            </div>
          </div>
        </div>
        <div class="login_right_bottom">
          <div>KEPCO AMS는 ㈜엘지유플러스가 ㈜한국전력공사에 납품하는 원격검침용 모뎀 운용 관리 업무를 수행하는 웹사이트입니다.</div>
          <div>서울특별시 용산구 한강대로 32 ㈜엘지유플러스 | 사업자등록번호 220-81-39938 사업자정보확인</div>
          <div>웹사이트 이용문의 : test@test.com 고객 문의의 원할한 적기 처리 및 이력 관리를 위해 위 번호로 문의 주시기 바랍니다.</div>
          <div>Copyright ⓒ LG Uplus Corp. All Rights Reserved.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import user from '../script/user'
import common from '../script/common'
import {defaultLoadingOptions} from '../script/defaultConfig'

export default {
  name: 'Login',
  data () {
    return {
      isMobileBrowser: common.detectMobileBrowser(),
      isLoginForm: true,
      userId: '',
      password: '',
      isSaveID: false,
      checkAgree: false
    }
  },
  mounted () {
    if (localStorage.getItem('amsUserId') != null &&
      localStorage.getItem('amsUserId') !== 'null' &&
      localStorage.getItem('amsUserId') !== '' &&
      localStorage.getItem('amsUserId').length > 0) {
      this.userId = localStorage.getItem('amsUserId')
      this.isSaveID = localStorage.getItem('isSaveID')
    }
  },
  methods: {
    login () {
      if (this.userId == null || this.userId.length <= 0) {
        common.amsAlert('general', '아이디를 입력해주세요.')
        return
      }
      if (this.password == null || this.password.length <= 0) {
        common.amsAlert('general', '패스워드를 입력해주세요.')
        return
      }
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      user.login({
        userId: this.userId,
        password: this.password
      }, response => {
        console.log('login', response)
        if (response.status !== 200) {
          vueLoadingOverlay.hide()
          console.error(response)
          common.amsAlert('contact', '잘못된 요청입니다.')
          return
        }
        if (response.data.resultCode === 1) {
          const userInfo = jwtDecode(response.data.result.body['authorization'])
          sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
          sessionStorage.setItem('accessToken', response.data.result.body['authorization'])
          sessionStorage.setItem('accessTokenRefresh', response.data.result.body['authorization-refresh'])
          localStorage.setItem('isSaveID', this.isSaveID)
          if (this.isSaveID) {
            localStorage.setItem('amsUserId', this.userId)
          } else {
            localStorage.removeItem('amsUserId')
          }
          user.getUser({
            userPid: userInfo.userPid
          }, response => {
            console.log('getUser', response)
            if (response.data.resultCode === 1) {
              sessionStorage.setItem('userInfoDetail', JSON.stringify(response.data.result.body))
            }
            vueLoadingOverlay.hide()
            this.$router.replace(this.isMobileBrowser ? '/ModemSearch' : '/Dashboard')
          })
        } else {
          vueLoadingOverlay.hide()
          common.amsAlert('contact', '잘못된 요청입니다.')
        }
      })
    },
    toggleLoginAndTerms () {
      this.isLoginForm = !this.isLoginForm
    },
    requestSignup () {
      if (!this.checkAgree) {
        common.amsAlert('general', '약관에 동의하지 않으시면 계정을 신청할 수 없습니다.')
        return
      }
      this.$router.push('/Join/Form')
    }
  }
}
</script>

<style scoped>
#login {
  display: flex;
  width: 100vw;
  height: 100vh;
}

.login_wrap {
  display: flex;
  margin: auto;
  gap: 30px;
}

.login_wrap > .login_top {
  display: none;
}

.login_wrap > .login_left {
  display: flex;
  flex-direction: column;
  width: 676px;
  height: 842px;
  border-radius: 16px;
  background: url('../assets/login/bg_login.png') center center no-repeat;
  background-size: cover;
  overflow: hidden;
  text-align: left;
}

.login_left > div {
  color: #ffffff;
}

.login_left > div:nth-child(1) {
  margin: auto 0 0 40px;
  line-height: 78px;
  font-family: 'NanumSquare', sans-serif;
  font-size: 60px;
  font-weight: 800;
  letter-spacing: -2px;
}

.login_left > div:nth-child(2) {
  margin: 0 0 0 40px;
  line-height: 78px;
  font-family: 'NanumSquare', sans-serif;
  font-size: 50px;
  font-weight: 800;
  letter-spacing: -2px;
}

.login_left > div:nth-child(3) {
  display: flex;
  height: 86px;
  margin: 92px 0 0 0;
  background: rgba(23, 23, 33, 0.75);
}

.login_left > div:nth-child(3) > div {
  margin: auto auto auto 60px;
  line-height: 21px;
  font-size: 14px;
  font-weight: 700;
}

.login_left > div:nth-child(3) > div:nth-child(2),
.login_left > div:nth-child(3) > div:nth-child(3) {
  display: none;
}

.login_left > div:nth-child(3) > div > span {
  color: #3EA2FF;
  text-decoration: underline;
  cursor: pointer;
}

.login_wrap > .login_right {
  display: flex;
  flex-direction: column;
}

.login_right > .login_right_top {
  display: flex;
  margin: 0 0 auto 0;
}

.login_right_top > img {

}

.login_right_top > img:nth-child(1) {
  margin: 0 0 0 auto;
}

.login_right_top > img:nth-child(2) {
  margin: 0 0 0 32px;
}

.login_right > .login_right_middle {
  width: 420px;
  margin: auto;
}

.login_right > .login_right_middle.terms {
  width: 618px;
}

.login_right_middle > .login_tit {
  line-height: 48px;
  color: #171721;
  font-size: 36px;
  font-weight: 700;
}

.login_right_middle > .login_desc {
  margin-top: 5px;
  line-height: 21px;
  color: #8083A3;
  font-size: 14px;
  font-weight: 400;
}

.login_right_middle > .login_input_wrap {
  display: flex;
  flex-direction: column;
  height: 72px;
  box-sizing: border-box;
  border: 1px solid #E4E6E8;
  border-radius: 10px;
}

.login_right_middle > .login_input_wrap:nth-child(3) {
  margin-top: 42px;
}

.login_right_middle > .login_input_wrap:nth-child(4) {
  margin-top: 17px;
}

.login_right_middle > .login_input_wrap > label {
  margin: 13px auto 0 20px;
  line-height: 18px;
  color: #8083A3;
  font-size: 12px;
  font-weight: 600;
}

.login_right_middle > .login_input_wrap > input {
  width: calc(100% - 36px);
  height: 21px;
  padding: 0 20px 0 0;
  border: none;
  margin: 4px 16px 0 20px;
  background: url('../assets/input/ic_input_message.svg') center right no-repeat;
  background-size: 18px 18px;
  box-sizing: border-box;
  outline: none;
  line-height: 21px;
  font-size: 12px;
  font-weight: 700;
}

.login_right_middle > .login_checkbox_wrap {
  display: flex;
  margin: 21px auto 0 0;
  gap: 10px;
}

.login_right_middle > .login_checkbox_wrap > input {
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
}

.login_right_middle > .login_checkbox_wrap > label {
  margin: auto 0;
  line-height: 18px;
  color: #171721;
  font-size: 12px;
  font-weight: 700;
}

.login_right_middle > .btn_login {
  border-radius: 10px;
  margin-top: 46px;
  background: #3E7EFF;
  line-height: 54px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.login_right > .login_right_bottom {
  margin: auto auto 0 auto;
}

.login_right_bottom > div {
  line-height: 21px;
  font-size: 12px;
}

/* Terms */
.login_right_middle > .join_term_wrap {
}

.join_term_wrap > .join_term_tit {
  margin: 27px 0 13px 12px;
  color: #171721;
  font-size: 12px;
  font-weight: 700;
  line-height: 21px;
  text-align: left;
}

.join_term_wrap > .join_term_content {
  position: relative;
  width: 618px;
  height: 404px;
  padding: 0 25px;
  border-radius: 10px;
  border: 1px solid #E4E6E8;
  box-sizing: border-box;
  opacity: 0.6;
}

.join_term_wrap > .join_term_content > .join_term_top_fade,
.join_term_wrap > .join_term_content > .join_term_bottom_fade {
  position: absolute;
  right: 0;
  left: 0;
  height: 25px;
  border-radius: 10px;
}

.join_term_wrap > .join_term_content > .join_term_top_fade {
  top: 0;
  background: linear-gradient(#ffffff 60%, rgba(255, 255, 255, 0));
}

.join_term_wrap > .join_term_content > .join_term_bottom_fade {
  bottom: 0;
  background: linear-gradient(rgba(255, 255, 255, 0), #ffffff 40%);
}

.join_term_wrap > .join_term_content > .join_term_box {
  width: 100%;
  height: 100%;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.join_term_wrap > .join_term_content > .join_term_box::-webkit-scrollbar {
  display: none;
}

.join_term_wrap > .join_term_content > .join_term_box > div {
  margin: 25px 0;
  color: #8083A3;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
}

.join_term_wrap > .join_term_bottom_wrap {
  display: flex;
  margin-top: 26px;
}

.join_term_bottom_wrap > .join_term_check {
  display: flex;
  margin: auto 0;
}

.join_term_bottom_wrap > .join_term_check > input[type=checkbox] {
  width: 18px;
  height: 18px;
  padding: 0;
  margin: auto;
}

.join_term_bottom_wrap > .join_term_check > label {
  margin: auto auto auto 10px;
  color: #171721;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.join_term_bottom_wrap > .btn_join_prev,
.join_term_bottom_wrap > .btn_join_next {
  width: 80px;
  height: 40px;
  border-radius: 10px;
  margin: auto 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 40px;
  cursor: pointer;
}

.join_term_bottom_wrap > .btn_join_prev {
  margin-left: auto;
  background: #F5F5FA;
  color: #3E7EFF;
}

.join_term_bottom_wrap > .btn_join_next {
  margin-left: 13px;
  background: #3E7EFF;
  color: #ffffff;
}

.mobile_wrap .login_wrap {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.mobile_wrap .login_wrap > .login_top {
  display: flex;
  margin: 13px 15px 0 0;
}

.mobile_wrap .login_top > img:nth-child(1) {
  width: 70px;
  height: 20px;
  margin: auto 0 auto auto;
}

.mobile_wrap .login_top > img:nth-child(2) {
  width: 119px;
  height: 18px;
  margin: auto 0 auto 12px;
}

.mobile_wrap .login_wrap > .login_left {
  width: 325px;
  height: 300px;
  border-radius: 30px;
  margin: 17px auto 0;
}

.mobile_wrap .login_left > div:nth-child(1) {
  display: none;
  margin-left: 22px;
  font-size: 22px;
  line-height: 1.5;
}

.mobile_wrap .login_left > div:nth-child(2) {
  display: none;
  margin-left: 22px;
  font-size: 18px;
  line-height: 1.5;
}

.mobile_wrap .login_left > div:nth-child(3) {
  display: flex;
  flex-direction: column;
  margin-top: auto;
  background: rgba(23, 23, 33, 0.3);
}

.mobile_wrap .login_left > div:nth-child(3) > div {
  margin: 0 0 0 22px;
  font-weight: 700;
  line-height: 1.5;
}

.mobile_wrap .login_left > div:nth-child(3) > div:nth-child(1) {
  display: none;
}

.mobile_wrap .login_left > div:nth-child(3) > div:nth-child(2) {
  margin-top: 9px;
  font-size: 22px;
}

.mobile_wrap .login_left > div:nth-child(3) > div:nth-child(3) {
  font-size: 18px;
}

.mobile_wrap .login_wrap > .login_right {
  margin-top: 29px;
}

.mobile_wrap .login_right > .login_right_top {
  display: none;
}

.mobile_wrap .login_right > .login_right_middle {
  width: 100%;
}

.mobile_wrap .login_right_middle > .login_tit {
  font-size: 18px;
  line-height: normal;
  letter-spacing: 0.5px;
}

.mobile_wrap .login_right_middle > .login_desc {
  font-size: 14px;
  line-height: 1.5;
}

.mobile_wrap .login_right_middle > .login_input_wrap {
  width: 326px;
  height: 66px;
  border: none;
  border-radius: unset;
  margin: auto;
}

.mobile_wrap .login_right_middle > .login_input_wrap:nth-child(3) {
  margin-top: 41px;
}

.mobile_wrap .login_right_middle > .login_input_wrap:nth-child(4) {
  margin-top: 10px;
}

.mobile_wrap .login_right_middle > .login_input_wrap > label {
  display: none;
}

.mobile_wrap .login_right_middle > .login_input_wrap > input {
  width: 100%;
  height: 66px;
  padding: 0 20px;
  border: none;
  border-radius: 20px;
  margin: 0;
  background: rgba(238, 238, 255, 0.3);
  box-sizing: border-box;
  outline: none;
  line-height: unset;
  font-size: 16px;
  font-weight: 500;
}

.mobile_wrap .login_right_middle > .login_checkbox_wrap {
  display: none;
}

.mobile_wrap .login_right_middle > .btn_login {
  width: 326px;
  border-radius: 20px;
  margin: 40px auto 0;
  line-height: 66px;
  font-size: 16px;
  font-weight: 500;
}

.mobile_wrap .login_right > .login_right_bottom {
  margin: 30px 16px;
}

.mobile_wrap .login_right_bottom > div {
  margin-top: 5px;
  color: #000000;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue